/**
 * Maximum number of evaluation samples allowed per specialized agent
 */
export const MAX_EVALUATION_SAMPLES = 5;
